// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sE2c","content":"styles_content__3EhJK","row":"styles_row__3lt_G","footer":"styles_footer__2WQgM","phraseLength":"styles_phraseLength__YQE9j"};